// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import { StyleSheet } from "react-native";
import colors from "../../config/colors";
import fonts from "../../config/fonts";
const DataTable1Style = StyleSheet.create({
  header: {
    flexDirection: "row",
    alignItems: "center",
    padding: 12,
    backgroundColor: colors.green,
    borderRadius: 16,
    shadowColor: colors.green,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 4,
    elevation: 3,
    marginTop: 10,
    marginBottom: 5,
    fontFamily: fonts.regular,
  },
  title: {
    fontSize: 18,
    fontWeight: "bold",
    flex: 1,
    color: colors.white,
    fontFamily: fonts.regular,
  },
  content: {
    paddingHorizontal: 12,
    paddingVertical: 10,
    fontFamily: fonts.regular,
  },
  labelsContainer: {
    marginTop: 16,
  },

  labelRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 6,
  },

  labelContainer: {
    alignItems: "center",
  },

  label: {
    fontWeight: "bold",
    fontFamily: fonts.regular,
  },
});
export default DataTable1Style;
